import { SidenavBannersComponent } from '../pages/banner/components/sidenav-banners/sidenav-banners.component';
import { SidenavFilterPostsComponent } from '../pages/posts/components/sidenav-filter-posts/sidenav-filter-posts.component';
import { SidenavPanelComponent } from '../pages/posts/components/sidenav-panel/sidenav-panel.component';

export const FILTER_OPTIONS = {
  componentRef: SidenavFilterPostsComponent,
  panelWidth: '250px',
};

export const BANNER_OPTIONS = {
  componentRef: SidenavBannersComponent,
  panelWidth: '350px',
};

export const PANEL_OPTIONS = {
  componentRef: SidenavPanelComponent,
  bgColor: 'bg-linear-to-b from-base-gray-light-50 to-base-gray-light-500',
};
